var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3857 5.47475C13.4026 3.50842 10.5974 3.50842 9.61523 5.47475L4.28484 16.142C3.39867 17.9137 4.68749 20 6.66961 20H17.3304C19.3125 20 20.6013 17.9146 19.7152 16.142L14.3857 5.47475ZM11.1112 9.33274C11.1112 9.09698 11.2048 8.87087 11.3715 8.70417C11.5382 8.53746 11.7643 8.4438 12 8.4438C12.2357 8.4438 12.4618 8.53746 12.6285 8.70417C12.7952 8.87087 12.8888 9.09698 12.8888 9.33274V12.8885C12.8888 13.1243 12.7952 13.3504 12.6285 13.5171C12.4618 13.6838 12.2357 13.7774 12 13.7774C11.7643 13.7774 11.5382 13.6838 11.3715 13.5171C11.2048 13.3504 11.1112 13.1243 11.1112 12.8885V9.33274ZM11.1112 15.5553C11.1112 15.3195 11.2048 15.0934 11.3715 14.9267C11.5382 14.76 11.7643 14.6664 12 14.6664C12.2357 14.6664 12.4618 14.76 12.6285 14.9267C12.7952 15.0934 12.8888 15.3195 12.8888 15.5553C12.8888 15.7911 12.7952 16.0172 12.6285 16.1839C12.4618 16.3506 12.2357 16.4442 12 16.4442C11.7643 16.4442 11.5382 16.3506 11.3715 16.1839C11.2048 16.0172 11.1112 15.7911 11.1112 15.5553Z",
    fill: "#E22716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1f472ae750c62b69f10e57fba19a8d20.svg";
export { ForwardRef as ReactComponent };